import { inventory_servie } from "../server/request";

export const getStorageLocationsData = async (catererId) => {
    try {
        let url = `/storageLocations?catererId=${catererId}`;

        const resp = await inventory_servie({
            method: 'GET',
            url: url
        });
        if (resp.status === 200) {
            return { success: true, data: resp.data };
        }
    } catch (ex) {
        return { error: true, errorMessage: ex.errorMessage }
    }
}
export const addNewStorageLocationRec = async (req) => {
    const { catererId, storageLocationName } = req;
    try {
        let url = `/storageLocations?catererId=${catererId}&storageLocationName=${storageLocationName}`;
        const resp = await inventory_servie({
            method: 'POST',
            url: url
        });
        if (resp.status == 201) {
            return { success: true, data: { ...resp, message: resp.data || '' } };
        } else {
            return { error: true, errorMessage: resp.data };
        }
    } catch (ex) {
        const errorObject = ex;
        const errorMessage = errorObject.message;
        return { error: true, errorMessage: errorMessage }
    }
}
export const saveStorageLocation = async (req) => {
    const { id, storageLocationName, catererId } = req;
    try {
        const url = `/storageLocations/${id}?catererId=${catererId}&storageLocationName=${storageLocationName}`;
        const resp = await inventory_servie({
            method: 'PUT',
            url: url
        });
        if (resp.status == 200) {
            return { success: true, data: { ...resp, message: resp.data || '' } };
        } else {
            return { error: true, errorMessage: resp.data };
        }

    } catch (ex) {
        const errorObject = ex;
        const errorMessage = errorObject.message;
        return { error: true, errorMessage: errorMessage };
    }
}
export const deleteStorageLocation = async (req) => {
    const { id, catererId } = req;
    try {
        const url = `/storageLocations/${id}?catererId=${catererId}`;
        const resp = await inventory_servie({
            method: 'DELETE',
            url: url
        });
        if (resp.status == 200) {
            return { success: true, data: { ...resp, message: resp.data || '' } };
        } else {
            return { error: true, errorMessage: resp.data };
        }

    } catch (ex) {
        const errorObject = ex;
        const errorMessage = errorObject.error;
        return { error: true, errorMessage: errorMessage };
    }
}